import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@material-ui/core';
import { ErrorOutline } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    paper: {
        border: `2px solid ${theme.palette.error.main}`,
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        backgroundColor: theme.palette.error.light,
    },
    icon: {
        fontSize: 32,
        color: theme.palette.error.contrastText,
    },
    titleText: {
        fontWeight: 600,
        color: theme.palette.error.contrastText,
    },
    body: {
        marginBottom: theme.spacing(2),
    },
    confirmButton: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
}));

const LinkedinUnsyncWarningDialog = ({ open, currentDatasetLabel, otherDatasetsLabel, onConfirm, onCancel }) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="sm"
            fullWidth
            classes={{ paper: classes.paper }}
        >
            <DialogTitle disableTypography className={classes.title}>
                <ErrorOutline className={classes.icon} />
                <Typography variant="h4" className={classes.titleText}>
                    Warning
                </Typography>
            </DialogTitle>

            <DialogContent dividers>
                <Typography className={classes.body}>
                    By selecting <strong>Yes</strong>, you are confirming that these records should no longer be considered the same individual.
                </Typography>
                <Typography className={classes.body}>
                    The {currentDatasetLabel} contact will be permanently unsynchronized from the other contact(s) it is currently associate with and future updates will no longer reconcile between these records automatically.
                </Typography>
                <Typography>
                    Are you sure you want to continue?
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>
                    No
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    className={classes.confirmButton}
                    startIcon={<ErrorOutline />}
                >
                    Yes, Unsync Records
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LinkedinUnsyncWarningDialog;